var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint2 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H2.5C1.80965 15 1.25 14.4404 1.25 13.75V8.75C1.25 8.05965 1.80965 7.5 2.5 7.5H17.5C18.1904 7.5 18.75 8.05965 18.75 8.75V13.75C18.75 14.4404 18.1904 15 17.5 15H15",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5V2.5C5 1.80965 5.55965 1.25 6.25 1.25H13.75C14.4404 1.25 15 1.80965 15 2.5V7.5",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.25H6.25C5.55964 11.25 5 11.8096 5 12.5V17.5C5 18.1904 5.55964 18.75 6.25 18.75H13.75C14.4404 18.75 15 18.1904 15 17.5V12.5C15 11.8096 14.4404 11.25 13.75 11.25Z",
    stroke: "#333333",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print2.c79bc904bf94377b755944eeafb613c3.svg";